// This file is auto-generated by localize-js, do not make edits to this file directly
import { getStringProvider } from '@fluidx/localize-js';
export async function getInformationProtectionStrings(translatedStringTableFetcher, locale) {
    const stringTableJson = await translatedStringTableFetcher(locale);
    return getStringProvider(stringTableJson, locale);
}
